import { combineReducers } from 'redux';

import byId from './byId';
import modal from './modal';

/**
 * @typedef {{
 *   byId: Record<string, import("modules/auditModels/types").AuditModel>
 *   modal: {
 *     duplicate: {
 *       auditModelId: string,
 *       dealerId: string,
 *       groupId: string,
 *     }
 *   }
 * }} AuditModelDataReducer,
 */

export default combineReducers({
  byId,
  modal,
});
